import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import {
  columnDescription,
  columnNameLink,
  columnSelect,
  columnVisibility,
} from '@/constants/fields';
import urls, { codeUrl } from '@/constants/urls';
import TableWrapper from '@/components/table/TableWrapper';
import NoRowsWithPagination from '@/components/table/NoRowsWithPagination';
import { fitToPage, goToCodePage } from '@/hooks/paging';
import CohortsTableHeader from '@/cohorts/components/CohortsTableHeader';
import CohortsTableRows from '@/cohorts/components/CohortsTableRows';
import RequestCohortsFilters from './RequestCohortsFilters';
import RequestCohortsContainer, {
  mapStateToProps,
  mapDispatchToProps,
} from '../components/RequestCohortsContainer';

const RequestCohortsTable = ({
  canCreate,
  category,
  className,
  code,
  columns = [
    columnSelect,
    columnNameLink,
    columnDescription,
    columnVisibility,
  ],
  currentPage,
  cohorts,
  fetchData,
  newCohortCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  total,
  theme,
}) => {
  const { items, pageNumber } = fitToPage(cohorts, currentPage, pageSize);
  const ref = React.useRef(null);

  return (
    <RequestCohortsContainer category={category} code={code} readStatus={readStatus} fetchData={fetchData}>
      <div className={clsx('ReactTable aridhia-select-cohorts', className)} ref={ref}>
        <TableWrapper sticky celled className="aridhia-cohorts-table" columns={columns} selectable>
          <CohortsTableHeader
            cohorts={items}
            columns={columns}
            readErrors={readErrors}
            readStatus={readStatus}
          >
            <RequestCohortsFilters category={category} code={code} className="aridhia-table-filter" />
          </CohortsTableHeader>
          <Table.Body>
            <CohortsTableRows
              items={items}
              columns={columns}
              onCheckBoxClick={(value) => onCheckBoxClick(category, code, value)}
              theme={theme}
              selectable
            />
          </Table.Body>
        </TableWrapper>
        <NoRowsWithPagination
          canCreate={canCreate}
          currentPage={pageNumber}
          entity="cohort"
          goToPage={({ page }) => goToCodePage(fetchData, category, code, page, ref)}
          items={items}
          icon="filter"
          newCohortCode={newCohortCode}
          pageCount={pageCount}
          readErrors={readErrors}
          readStatus={readStatus}
          total={total}
          url={codeUrl(urls.COHORT, newCohortCode, '#')}
        />
      </div>
    </RequestCohortsContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestCohortsTable);
